import useCopilotAccountOwnerId from 'components/CopilotControl/hooks/useCopilotAccountOwnerId'
import useCopilotPatientsList from 'components/CopilotControl/hooks/useCopilotPatientsList'
import _ from 'lodash'
import React, { useMemo } from 'react'
import {
  useFetchNeedsAttentionAggregationQuery,
  useFetchNeedsAttentionPatientsInfiniteQuery
} from 'store/modules/CopilotControl'
import PatientsList from '../../common/PatientsList/PatientsList'
import NeedsAttentionEmptyState from './NeedsAttentionEmptyState'
import NeedsAttentionHeader from './NeedsAttentionHeader'
import NeedsAttentionHeaderSkeleton from './NeedsAttentionHeaderSkeleton'
import NeedsAttentionPatientItem from './NeedsAttentionPatientItem'

const NeedsAttentionList = () => {
  const accountOwnerId = useCopilotAccountOwnerId()
  const { isStatusesLoading, selectedNeedsAttentionReasons, handleSelectedNeedsAttentionReasonsUpdated } =
    useCopilotPatientsList()

  const {
    data: patients = [],
    isLoading,
    isFetching,
    isFetchingNextPage,
    fetchNextPage
  } = useFetchNeedsAttentionPatientsInfiniteQuery({
    accountOwnerId,
    selectedReasons: selectedNeedsAttentionReasons
  })

  const patientsPaginatedData = useMemo(() => {
    return patients.pages?.map(page => page.items).flat() || []
  }, [patients])

  const hasMorePages = useMemo(() => _.last(patients?.pages || [])?.hasMore, [patients])

  const { data: needsAttentionAggregationData = {}, isLoading: isLoadingAggregations } =
    useFetchNeedsAttentionAggregationQuery({ accountOwnerId }, { skip: !accountOwnerId })

  const isListLoading = useMemo(
    () => isLoading || isStatusesLoading || isFetching,
    [isLoading, isFetching, isStatusesLoading]
  )

  const totalNeedsAttention = useMemo(
    () => _.sum(Object.values(needsAttentionAggregationData)),
    [needsAttentionAggregationData]
  )

  return (
    <PatientsList
      isHeaderLoading={isLoadingAggregations}
      isListLoading={isListLoading && !isFetchingNextPage}
      totalPatients={totalNeedsAttention}
      isEmpty={totalNeedsAttention === 0}
      fetchNextPage={fetchNextPage}
      hasMorePages={hasMorePages}
      patients={patientsPaginatedData}
      EmptyStateComponent={<NeedsAttentionEmptyState />}
      HeaderSkeletonComponent={<NeedsAttentionHeaderSkeleton />}
      PatientsHeaderComponent={
        <NeedsAttentionHeader
          total={totalNeedsAttention}
          countsByReasons={needsAttentionAggregationData}
          selectedReasons={selectedNeedsAttentionReasons}
          setSelectedReasons={handleSelectedNeedsAttentionReasonsUpdated}
        />
      }
      PatientListItemComponent={NeedsAttentionPatientItem}
    />
  )
}

export default NeedsAttentionList
